
export const TestimonialFilterForTACOnly = [
    {
      id: 1,
      name: "ICP",
      value: "icp",
    },
    {
      id: 2,
      name: "APO",
      value: "apo",
    },
    {
      id: 3,
      name: "PDM",
      value: "pdm",
    },
    {
      id: 5,
      name: "APM",
      value: "agile_project_management",
    },
    {
      id: 4,
      name: "ACC",
      value: "acc",
    },
    {
      id: 5,
      name: "ATF",
      value: "atf",
    },
    {
      id: 6,
      name: "FAI",
      value: "fai",
    },
 
  ];

  export const TestimonialFilterForTAAOnly = [
    {
      id: 1,
      name: "PDM",
      value: "pdm",
    },
    {
      id: 1,
      name: "TAC-ICP",
      value: "icp",
    },
    {
      id: 2,
      name: "TAC-APO",
      value: "apo",
    },
    {
      id: 3,
      name: "TAC-PDM",
      value: "pdm",
    },
  ];